<template>
  <span
    v-if="exportation_type_id == 0"
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-gray-100 text-gray-800"
  >
    <i class="fa-solid fa-ship my-1"></i>
    <span class="space-icon" v-if="!only_icon"></span>
    <span v-if="!only_icon">{{ prepend_label }} Marítimo</span>
  </span>
  <span
    v-if="exportation_type_id == 1"
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-gray-100 text-gray-800"
  >
    <i class="fa-solid fa-plane-departure my-1"></i>
    <span class="space-icon" v-if="!only_icon"></span>
    <span v-if="!only_icon">{{ prepend_label }} Aéreo</span>
  </span>
</template>

<script>
export default {
  name: "AEProductionQueryContainerExportExportationType",
  props: ["exportation_type_id", "prepend_label", "only_icon"],
};
</script>
